<div class="wrapper">
  <div class="container px-0 mt-2">
    <!--<h5 class="main-title">{{patientPersonalInfo.PracticeName || 'N/A'}}</h5>-->
    <div class="pdf-viewer">
      <pdf-viewer [src]="pdfPath1"
                  style="display: block; height: 100%; width:100%;"
                  (error)="onError($event)"
                  (on-progress)="onProgress($event)"
                  [external-link-target]="'blank'"
                  [show-borders]="true"
                  [zoom]="zoopLevel"
                  [autoresize]="true"
                  (after-load-complete)="loaded($event)"
                  [fit-to-page]="false"
                  [zoom-scale]="'page-width'"
                  [show-borders]="false"></pdf-viewer>
    </div>
  </div>
</div>

<footer class="p-3">
  <div class="container p-0">
    <div class="d-flex justify-content-between align-items-center">
      <!--<button class="btn btn-outline-primary v-hidden pointer-none" type="button" data-toggle="modal" data-target="#DisagreeModal">{{'consent_form.consent_form_I_Disagree' |translate}}</button>-->
      <!--<p class="mb-0">({{pageNum}} {{'generic_text.of'|translate}} {{totalPages}})</p>-->
      <!--<button class="btn btn-primary" type="button" (click)="onIAgreeClick()">{{'consent_form.consent_form_I_Agree' |translate}}</button>-->
      <button class="btn btn-outline-primary v-hidden pointer-none" type="button" data-toggle="modal" data-target="#DisagreeModal">{{'consent_form.consent_form_I_Disagree' |translate}}</button>
      <button class="btn btn-primary" type="button" (click)="onIAgreeClick()">{{'button.next' |translate}}</button>
    </div>
  </div>
</footer>

<div data-backdrop="static" data-keyboard="false" class="modal modal-md collapse" id="SignatureModal">
  <div class="modal-dialog modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'consent_form.consent_form_Add_Signature' |translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="clearSignature()" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-0">
        <div class="bg-light signature-area">
          <span *ngIf="isEmpty" style="top: 50%; left: 50%; position: absolute; transform: translate(-50%, -50%); color: #4b4747; font-weight: 500; text-transform: capitalize; ">
            {{ 'consent_form.consent_form_signature_here'| translate }}
          </span>
          <a *ngIf="signaturePad && !signaturePad.isEmpty()" href="javascript:void(0)" class="btn btn-secondary btn-sig btn-sm" (click)="clearSignature()"> {{'button.clear'|translate}} </a>
          <!--<signature-pad [options]="signaturePadOptions" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()"></signature-pad>-->
          <canvas #signatureCanvas width="500" (onBeginEvent)="drawStart()" (onEndEvent)="drawComplete()" height="300"></canvas>
        </div>
        <!-- <div class="bg-light signature-area" [ngClass]="patientName == '' ? 'sign-here' : 'patient-name'">
          {{patientName}}
        </div>  -->
        <div class="border-bottom border-left border-right border-top-0" style="padding: 10px;">
          <div class="custom-control custom-checkbox">
            <input #agree class="custom-control-input" checked (change)="agreeToTerms($event)" type="checkbox" id="idCheck">
            <label class="custom-control-label" for="idCheck"> {{'consent_form.consent_form_I_Agree_to_the_terms_conditions' |translate}}</label>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="clearSignature()" class="close" data-dismiss="modal" aria-label="Close" class="btn btn-outline-primary ">{{'button.close'|translate}}</button>
        <button [attr.disabled]="patientName == '' ? true : null" (click)="applySIgnature()" class="btn btn-primary ">{{'button.apply'|translate}}</button>
      </div>
    </div>
  </div>
</div>


<!-- disagree mmodal  -->
<div class="modal fade in modal-alert bd-example-modal-sm" id="DisagreeModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body  p-4 text-center">
        <h5 class="font-weight-bolder mb-3 text-danger"><strong>{{'consent_form.consent_form_Are_you_sure_you_want_to_exit'|translate}}</strong></h5>
        <button type="button" class="btn btn-outline-primary mr-2" data-dismiss="modal" id="DisagreeModal">  {{'button.no'|translate}}</button>
        <button type="button" (click)="dissAgreedClicked()" data-dismiss="modal" class="btn btn-primary ">{{'button.yes'|translate}}</button>
      </div>
    </div>
  </div>

</div>

<!-- consnet modal -->
<div class="modal fade in modal-alert bd-example-modal-sm" id="ConsentModal" tabindex="-1" role="dialog" data-backdrop="static" data-keyboard="false">

  <div class="modal-dialog modal-dialog-centered">

    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'consent_form.consent_form_acknowledge' |translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body p-3">
        <p [ngClass]="{'text-left':!isRTL,'text-right':isRTL}">{{'consent_form.I_Agree_to_the_terms_conditions_consent_form' |translate}}</p>
        <div class="text-center">
          <button type="button" class="btn btn-outline-primary" [ngClass]="{'mr-3':!isRTL,'ml-3':isRTL}" data-dismiss="modal">{{'consent_form.consent_form_I_Disagree' |translate}}</button>
          <button (click)="addConsent()" class="btn btn-primary">{{'consent_form.consent_form_I_Agree' |translate}}</button>
        </div>

      </div>
    </div>
  </div>

</div>
